<script>
  import { onMount } from "svelte";
  import axios from "axios";
  // import svgson from "svgson";
  // import snapsvg from "snapsvg";

  // import { SVG } from "@svgdotjs/svg.js";

  // import svglogo from "./demo.svg";

  const params = new URLSearchParams(window.location.search);  
  const logoUrl = params.get("logo");  

  onMount(() => {

    // axios
    //   .get("https://upload.wikimedia.org/wikipedia/commons/8/84/Example.svg")
    //   .then(response => response.data)
    //   .then(svg => {
    //     return svgson.parse(svg).then(svg => {
    //       return svgson.stringify(svg);
    //     });
    //   })
    //   .then(svg => {
    //     // var parsed = Snap.parse(svg);
    //     // var s = Snap("#logo-white");
    //     // s.append(parsed);
    //     // s.transform('s0.5');
    //     // s.attr({ viewBox: "0 0 400 400" });
    //     // var r = s.rect(100,100,100,100,20,20).attr({ stroke: '#123456', 'strokeWidth': 20, fill: 'red', 'opacity': 0.2 });
    //     // logo_white.addTo('#logo-white');
    //     ///////////
    //     // var logo_white = SVG(svg);
    //     // logo_white.scale(0.5, 0.5)
    //     // // logo_white.viewbox({ x: 0, y: 0, width: 100, height: 210 })
    //     // logo_white.size(400, 400);
    //     // logo_white.fill('#ffffff');
    //     // var logo_black = SVG(svg);
    //     // logo_black.fill('#000000');
    //     // logo_white.addTo('#logo-white');
    //     // logo_black.addTo('#logo-black');
    //   });

    

  });    
</script>

<svelte:head>
  <title>Mocka Prototype</title>
</svelte:head>


<div class="container ">

  <div class="justify-center flex my-10">
    <p class="text-4xl">MOCKA PROTOTYPE</p>
  </div>

  <div class="flex mb-4">
    <div class="w-1/2 h-64 m-1 bg-gray-900 rounded shadow-lg flex justify-center">
      <img class="w-1/3 object-scale-down" alt="" src={logoUrl} />
    </div>

    <div class="w-1/2 h-64 m-1 bg-gray-100 rounded shadow-lg flex justify-center">
      <img alt="" class="w-1/3 object-scale-down" src={logoUrl} />
    </div>
  </div>

  <div class="justify-center flex mt-32 my-10">
    <p class="text-2xl">MONOCHROME</p>
  </div>

  <!-- Two columns -->
  <div class="flex mb-4">
    <div class="w-1/2 h-64 m-1 bg-gray-900 rounded shadow-lg flex justify-center">
      <img style="filter: brightness(0) invert(100%); " class="w-1/3 object-scale-down" alt="" src={logoUrl} />
    </div>

    <div class="w-1/2 h-64 m-1 bg-gray-100 rounded shadow-lg flex justify-center">
      <img style="filter: brightness(0);" alt="" class="w-1/3 object-scale-down" src={logoUrl} />
    </div>
  </div>

  <div class="justify-center flex mt-32 my-10">
    <p class="text-2xl">RAINBOW</p>
  </div>

  <div class="flex mb-4">
    <div class="w-1/3 m-1 bg-red-700 h-40 rounded shadow-lg flex justify-center"><img class="w-1/3 object-scale-down m-4" alt="" src={logoUrl} /></div>
    <div class="w-1/3 m-1 bg-green-700 h-40 rounded shadow-lg flex justify-center"><img class="w-1/3 object-scale-down m-4" alt="" src={logoUrl} /></div>
    <div class="w-1/3 m-1 bg-blue-700 h-40 rounded shadow-lg flex justify-center"><img class="w-1/3 object-scale-down m-4" alt="" src={logoUrl} /></div>
  </div>

  <div class="flex mb-4">
    <div class="w-1/3 m-1 bg-orange-500 h-40 rounded shadow-lg flex justify-center"><img class="w-1/3 object-scale-down m-4" alt="" src={logoUrl} /></div>
    <div class="w-1/3 m-1 bg-pink-500 h-40 rounded shadow-lg flex justify-center"><img class="w-1/3 object-scale-down m-4" alt="" src={logoUrl} /></div>
    <div class="w-1/3 m-1 bg-yellow-500 h-40 rounded shadow-lg flex justify-center"><img class="w-1/3 object-scale-down m-4" alt="" src={logoUrl} /></div>
  </div>

  <div class="justify-center flex mt-32 my-10">
    <p class="text-2xl">MOBILE (iOS)</p>
  </div>

  <div class="flex mb-4 justify-center">
  <div class="marvel-device iphone-x ">
    <div class="notch">
        <div class="camera"></div>
        <div class="speaker"></div>
    </div>
    <div class="top-bar"></div>
    <div class="sleep"></div>
    <div class="bottom-bar"></div>
    <div class="volume"></div>
    <div class="overflow">
        <div class="shadow shadow--tr"></div>
        <div class="shadow shadow--tl"></div>
        <div class="shadow shadow--br"></div>
        <div class="shadow shadow--bl"></div>
    </div>
    <div class="inner-shadow"></div>
    <div class="screen ">
        <div class="flex justify-center mt-16">
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0) invert(100%);" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
        </div>
        <div class="flex justify-center mt-10">
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0) invert(100%);" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
        </div>
        <div class="flex justify-center mt-10">
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0) invert(100%);" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
        </div>
        <div class="flex justify-center mt-10">
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0) invert(100%);" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
        </div>
        <div class="flex justify-center mt-10">
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0) invert(100%);" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
        </div>
        <div class="flex justify-center mt-10">
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0) invert(100%);" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="w-10/12 object-scale-down" style="filter: brightness(0;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down" alt="" src="img/icon.png" />
        </div>

        <div style="border-radius: 30px;" class="flex justify-center mt-16 bg-gray-600 py-4 mx-4">
          <img class="w-1/6 mx-3 object-scale-down opacity-25" alt="" src="img/icon.png" />
          <div style="border-radius: 9px;" class="flex justify-center bg-black mx-3 w-1/6"><img class="object-scale-down" style="filter: brightness(0) invert(100%); border-radius: 9px;" alt="" src={logoUrl} /></div>
          <div style="border-radius: 9px;" class="flex justify-center bg-white mx-3 w-1/6"><img class="object-scale-down" style="filter: brightness(0; border-radius: 9px;" alt="" src={logoUrl} /></div>
          <img class="w-1/6 mx-3 object-scale-down opacity-25" alt="" src="img/icon.png" />
        </div>
    </div>
</div>
  </div>

</div>
